import { ApplicationConfig, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { environment } from '../../../../libs/environment/environment';
import { startWebVitals } from '../../../../libs/core/service/web-vitals';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { superadminAuthInterceptor } from './auth/auth.interceptor';
import { apiToastInterceptor } from '../../../../libs/core/service/api-toast.interceptor';
import { zonelessChangeDetectionInterceptor } from './zoneless-change-detection.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    // Real-user page speed; off until environment.webVitalsUrl is set.
    provideAppInitializer(() => startWebVitals('superadmin', environment.webVitalsUrl)),
    provideHttpClient(withFetch(), withInterceptors([superadminAuthInterceptor, apiToastInterceptor, zonelessChangeDetectionInterceptor])),
    provideRouter(appRoutes),
  ],
};
